export enum PropertyLocationType {
  Property = 'Property',
  RailwayStation = 'Railway Station',
  Airport = 'Airport',
  MetroStation = 'Metro Station',
  Mall = 'Mall',
  Roadway = 'Roadway',
  Other = 'Other',
}
